import React, { useContext, useEffect, useMemo, useReducer } from "react";
import { ParentContext } from "../../../../global/cnr/contexts/ParentContext";
import { getFirstObject } from "../../../../global/common/convert";
import { sportsMatchHandlers, sportsMatchInitialState, sportsMatchReducer } from "../reducers/SportsMatchReducer";
import { SeasonMatchesContext } from "./SeasonMatchesContext";
import { SportsSeasonContext } from "./SportsSeasonContext";
import { useSportMatch } from "projectSpecific/sports/useHelpers/useSportMatch";

export const SportsMatchContext = React.createContext()

export default function SportsMatchProvider(props) {

  const {
    levelKey,
    sectionKey,
    dateKey,
    matchKey,
    match,
    teamKey
  } = props ?? {}

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states, fns } = parentContext ?? {}
  const { appUser_state, paps_state, currentSettings_state } = states ?? {}
  const { appUser_fns } = fns ?? {}
  const { accessClone } = appUser_state ?? {}
  const { pathViews } = paps_state ?? {}
  const { matches: match_key } = pathViews ?? {}

  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { sportSettings } = aps_global ?? {}
  const { matchResultFullBackground } = sportSettings ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const {
    _sportData,
    _sportSeasonSettings,
    details_info,
    matches_info,
    parentDataKeys,
    playoffDates,
    currentSeason_info,
    tournamentType,
  } = sportsSeason_state ?? {}

  const _matches_info = matches_info;
  const { matches_groupInfo } = _matches_info ?? {};
  const { levelKeys, levelLatestStartDates, scheduleLevelKeys: _scheduleLevelKeys, levelSectionDateMatches: _levelSectionDateMatches } = matches_groupInfo ?? {};

  // const lsdms = _levelSectionDateMatches?.[levelKey]?.[dateKey]?.[sectionKey]

  const { latestSeason, sportsKey, gameScoringType, gameAllowTies, _sportsModeSport } = currentSeason_info ?? {}
  const { matches_combined, matches_matchDay } = matches_info ?? {}
  const { matches_seasonal: pk_matches_seasonal } = parentDataKeys ?? {}

  const { details } = details_info ?? {}
  const { sportsScoringAuthType } = details ?? {}

  // seasonMatchesContext
  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const componentContexts = { sportsSeasonContext, seasonMatchesContext }

  const init_state = { _sportData }

  const [sportsMatch_state, sportsMatch_dispatch] = useReducer(sportsMatchReducer, init_state, sportsMatchInitialState)
  const { matchAllows, match_true } = sportsMatch_state ?? {}
  const { _itemKey } = match_true ?? {}

  const { getMatchCn } = useSportMatch({ matchAllows })

  const sportsMatch_handlers = useMemo(
    () => sportsMatchHandlers(sportsMatch_dispatch),
    [sportsMatch_dispatch]
  );

  const _sportsMatchCn = useMemo(() => {
    return getMatchCn(match_true, teamKey, matchKey)
  }, [match_true, matchAllows]);

  const addOpponentToMatch = (tm, teamKey) => {
    if (!tm?.home?.id || !tm?.away?.id) return _.cloneDeep(tm);

    return {
      ...tm,
      opponent: tm.home.id === teamKey ? tm.away : tm.home
    };
  };

  const _trueMatch = useMemo(() => {
    if (match) return match;
    if (matchKey) return matches_combined?.[matchKey];
    if (match_key) return matches_combined?.[match_key];
    return null;
  }, [matchKey, match_key, JSON.stringify(match), matches_combined]);

  const _matchDayMatchData = useMemo(() => {
    if (!matches_matchDay) return {};

    const rtm_currentMatch = matches_matchDay[_itemKey];
    if (!rtm_currentMatch) return {};

    const rtm = getFirstObject(rtm_currentMatch);
    const { item } = rtm ?? {};
    const { displayName, results } = item ?? {};

    return results
      ? { match_dy: results, match_rt_scorer: displayName }
      : {};
  }, [matches_matchDay, _itemKey]);

  const _matchAllows = useMemo(() => {
    const maProps = { match_true, sportsKey, accessClone, sportsScoringAuthType };
    return appUser_fns.validateAccess_allowScoring(maProps);
  }, [match_true, sportsKey, accessClone, sportsScoringAuthType]);

  useEffect(() => {
    if (_trueMatch) {
      sportsMatch_handlers.handleSet_trueMatch(addOpponentToMatch(_trueMatch, teamKey));
    }
  }, [JSON.stringify(_trueMatch), sportsMatch_handlers]);

  useEffect(() => {
    sportsMatch_handlers.handleSet_matchAllowances(_matchAllows);
  }, [_matchAllows]);

  useEffect(() => {
    sportsMatch_handlers.handleSet_matchDayMatchData(_matchDayMatchData);
  }, [_matchDayMatchData]);

  return <SportsMatchContext.Provider value={{
    sportsMatch_state,
    sportsMatch_handlers,
    componentContexts,
    sportsMatch_cn: _sportsMatchCn
  }}>
    {props.children}
  </SportsMatchContext.Provider>

}